<div class="card mt-2 py-1 px-1">
  @if (index != undefined) {
    <div class="d-flex row c-pointer" data-bs-toggle="collapse"
      [attr.data-bs-target]="'#collapseExample' + index" aria-expanded="false"
      [attr.aria-controls]="'collapseExample' + index" (click)="toggleComponent(index)">
      <span class="d-flex justify-content start w-80">
        @if (deliveryDay != undefined) {
          <h5 i18n="@@DeliveryReminderDeliveryDayLabel">Delivery day: {{ deliveryDay |
        eDayOfWeekToStringPipe }}</h5>
        }
      </span>
      <span class="d-flex justify-content-end w-20">
        @if (index != undefined) {
          <div class="d-flex custombutton">
            <i [class.icon]="true" [class.open]="componentVisibleList[index]" class="bi bi-arrow-left-short icon"></i>
          </div>
        }
      </span>
    </div>
  }

  <div class="pt-2 collapse" [attr.id]="'collapseExample' + index">
    <div class="container px-0 mt-1">
      @for (deliveryReminder of deliveryReminderList; track deliveryReminder; let i = $index) {
<div class="box" [ngClass]="{
          'active': selectedDay == deliveryReminder.day,
          'deliveryday': deliveryDay == deliveryReminder.day,
          'disabled': isDayDisabled(deliveryReminder.day),
          'smsday': deliveryReminder.isSmsDay,
          'mailday': deliveryReminder.isMailDay,
          'bothday': deliveryReminder.isBothDay
        }" (click)="selectDay(deliveryReminder.day)">
          {{ deliveryReminder.day | eDayOfWeekToStringPipe: true }}
          @if (deliveryReminder.isSmsDay) {
            <i class="bi bi-phone-vibrate ms-2"></i>
          }
          @if (deliveryReminder.isMailDay) {
            <i class="bi bi-envelope-at ms-2"></i>
          }
          @if (deliveryDay == deliveryReminder.day) {
            <i class="bi bi-truck ms-2"></i>
          }
        </div>
      }
    </div>
    @if (selectedDay) {
      <div>
        <div class="editcontainer">
          <div class="selection">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="sendSMS">
              <label class="form-check-label" for="flexCheckDefault" i18n="@@DeliveryReminderSMSLabel">
              SMS reminder
            </label>
              @if (sendSMS) {
                <span>
                  <label i18n="@@DeliveryReminderMailSMSLabel">time:</label>
                  @if (deliveryDay != undefined && selectedDay == deliveryDay - 1) {
                    <select [(ngModel)]="smsTime">
                      @for (hour of hoursBeforeDeliveryDay; track hour) {
                        <option [value]="hour">{{ hour }}</option>
                      }
                    </select>
                  }
                  @if (deliveryDay != undefined && selectedDay != deliveryDay - 1) {
                    <select [(ngModel)]="smsTime">
                      @for (hour of hours; track hour) {
                        <option [value]="hour">{{ hour }}</option>
                      }
                    </select>
                  }
                </span>
              }
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="sendEmail">
              <label class="form-check-label" for="flexCheckChecked" i18n="@@DeliveryReminderMailLabel">
              Mail reminder
            </label>
              @if (sendEmail) {
                <span>
                  <label i18n="@@DeliveryReminderMailTimeLabel">time:</label>
                  @if (deliveryDay != undefined && selectedDay == deliveryDay - 1) {
                    <select [(ngModel)]="mailTime">
                      @for (hour of hoursBeforeDeliveryDay; track hour) {
                        <option [value]="hour">{{ hour }}</option>
                      }
                    </select>
                  }
                  @if (deliveryDay != undefined && selectedDay != deliveryDay - 1) {
                    <select [(ngModel)]="mailTime">
                      @for (hour of hours; track hour) {
                        <option [value]="hour">{{ hour }}</option>
                      }
                    </select>
                  }
                </span>
              }
            </div>
          </div>
          <div class="buttonsave">
            <button class="btn btn-primary btn-pretty" (click)="saveInputsAsync()"
            i18n="@@DeliveryReminderSaveButton">Save</button>
          </div>
        </div>
      </div>
    }
  </div>
</div>